import { Constants } from "@repobit/dex-constants";
import { BDUUIDData, ScriptParameters } from "./typeDefinitions";

export function loadScript(src: string, attrs: ScriptParameters = {}): Promise<void> {
  return new Promise((resolve, reject) => {
    if (!document.querySelector(`head > script[src="${src}"]`)) {
      const script = document.createElement('script');
      script.src = src;
      for (const attr in attrs) {
        script.setAttribute(attr, attrs[attr]);
      }

      script.onload = () => resolve();
      script.onerror = reject;
      document.head.append(script);
    } else {
      resolve();
    }
  });
}

// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export function throttle(callback: Function, delay: number = 250): Function {
  let shouldWait = false;

  return (...args: unknown[]) => {
    if (shouldWait) {
      return;
    }

    shouldWait = true;
    setTimeout(() => {
      callback(...args);
      shouldWait = false;
    }, delay);
  };
}

// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export function debounce(callback: Function, delay: number = 250, immediate: boolean = false) {
  let timeout: NodeJS.Timeout | null = null;

  return (...args: unknown[]) => {
    const later = () => {
      timeout = null;
      if (!immediate) {
        callback(...args);
      }
    };

    const callNow = immediate && !timeout;
    clearTimeout(timeout as NodeJS.Timeout);
    timeout = setTimeout(later, delay);
    if (callNow) {
      callback(...args);
    }
  };
}

export async function getUserVisitorId(): Promise<string> {
  try {
    const uuidFetchCall = await fetch(`${Constants.PUBLIC_URL_ORIGIN}/bduuid`);
    const uuidFetchData: BDUUIDData = await uuidFetchCall.json();

    return uuidFetchData.bd_visitor_id;
  } catch {
    return '';
  }
}